export default __webpack_public_path__ + "255c9283883d274342f4a42bfb2203b2.svg";